import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MenuTermsPage } from './menu-terms.page';

const routes: Routes = [
  {
    path: '',
    component: MenuTermsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuTermsPageRoutingModule {}
